import "./FeedBackGrid.scss";
import "../../globals/scss/font.scss";
import { Box, Grid, Rating } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import api_call from "../../globals/common_utilities/axios_old";
import CONSTANTS from "../../globals/common_utilities/constant";
import moment from "moment";
import React, { useState, useRef, useEffect } from "react";

const FeedBackGrid = (props) => {
  const { array_1, array_2, gotoFeedBAckChart } = props;
  const add3Dots = (string, limit) => {
    let dots = "...";
    if (string.length > limit) {
      string = string.substring(0, limit) + dots;
    }
    return string;
  };
  return (
    <>
      <Box className="feedback_grid">
        <Box className="countryName_label medium_f">
          <span>
            {/* {array_1.region_training.region_name} */}
            {array_1?.region_training?.region_name.length > 25
              ? `${array_1?.region_training?.region_name.slice(0, 25)}...`
              : array_1?.region_training?.region_name}
          </span>
        </Box>
        <Box className="margin_container" marginTop={"5%"}>
          <span className="fs-4">Training Name -</span>
          <span className="fs-3">
            {array_1?.title.length > 15
              ? `${array_1?.title?.slice(0, 15)}...`
              : array_1?.title}
          </span>
        </Box>
        <Grid container className="margin_container" columnSpacing={0}>
          <Grid item xs={4}>
            <Box className="feedback_grid_date" width={"90%"}>
              <span className="fs-4">
                {" "}
                {moment(array_1?.created_at).format("DD/MM/YYYY")}
              </span>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="feedback_grid_instructor" width={"105%"}>
              <span className="fs-4"> Instructor - </span>
              <span className="fs-3">
                {" "}
                {/* {array_1?.user?.name} */}
                {/* {array_1?.user?.name.length > 15
									? `${array_1?.user?.name.slice(0, 12)}...`
									: array_1?.user?.name} */}
                {add3Dots(array_1?.user?.name, 10)}
              </span>
            </Box>
          </Grid>
        </Grid>
        <Box className="margin_container">
          <Grid container rowSpacing={1}>
            <Grid item xs={12}>
              <Grid
                container
                item
                xs={12}
                direction="row"
                justifyContent="space-between"
                className="feedback_grid_container"
              >
                <span className="fs-4">Total Student :</span>
                <span className="fs-3"> {array_2?.total_student_count}</span>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                item
                xs={12}
                direction="row"
                justifyContent="space-between"
                className="feedback_grid_container"
              >
                <span className="fs-4">Ratings :</span>
                <span>
                  <Rating
                    name="size-small"
                    size="small"
                    defaultValue={
                      array_1?.training_rating ? array_1?.training_rating : 0
                    }
                    precision={0.1}
                    readOnly
                  />
                </span>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                item
                xs={12}
                direction="row"
                justifyContent="center"
                className="view_feedback_Button fs-3"
              >
                <button onClick={() => gotoFeedBAckChart({ array_1, array_2 })}>
                  {" "}
                  View Feedback
                </button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default FeedBackGrid;
